import { fontSize } from '@/styles/font'
import spaceStyle from '@/styles/space'
import { IconPosition } from '@/components/base/Button/Base'
import { LocalIconType } from '@/components/base/Icon'
import { useApp } from '@/hooks/useApp'
import useIsMobile from '@/hooks/useMobile'
import styled from 'styled-components'
import { PrimaryButton } from '../base/Button'

const StyledScrollToTop = styled.div<Props>`
  position: sticky;
  bottom: 5px;
  right: 5px;
  width: max-content;
  margin-left: auto;
  margin-right: ${(props) => (props.isMobile ? '0px' : '-94px')};
  margin-top: ${(props) => (props.isMobile ? '0px' : '-64px')};
  z-index: 10;
`
interface Props {
  isMobile: boolean
}

const ScrollToTopButton = (): JSX.Element => {
  const app = useApp()
  const isMobile = useIsMobile()

  const scrollToTop = (): void => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  return (
    <StyledScrollToTop isMobile={isMobile}>
      <PrimaryButton
        width={'64px'}
        height={'64px'}
        padding={{ vertical: spaceStyle.XS }}
        iconProps={{
          iconType: LocalIconType.ArrowUpward,
          iconStyle: {
            margin: { left: spaceStyle.NONE },
            fontSize: fontSize.XXL,
            theme: app.theme.whiteColor
          },
          position: IconPosition.right
        }}
        onClick={scrollToTop}
      ></PrimaryButton>
    </StyledScrollToTop>
  )
}

export default ScrollToTopButton
